import React from "react";
import {Layout, Menu} from "antd";
import {ControlOutlined, LockOutlined} from "@ant-design/icons";
import PasswordPolicyPage from "../password/PasswordPolicyPage";
import AccountActivateSetting from "./AccountActivateSetting";
import i18next from "i18next";
import {Redirect, Route, Switch} from "react-router-dom";

const {Content, Sider} = Layout;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const menuPath = {
  "password": "/syssetting/password",
  "activation": "/syssetting/activation",
};

export const SystemSetting = (props) => {
  const getDefaultSelectedKeys = () => {
    if (props.location.pathname.startsWith("/syssetting/password")) {
      return ["password"];
    } else if (props.location.pathname.startsWith("/syssetting/activation")) {
      return ["activation"];
    }

    return ["password"];
  };

  const getDefaultOpenKeys = () => {
    if (props.location.pathname.startsWith("/syssetting/password")) {
      return ["password"];
    } else if (props.location.pathname.startsWith("/syssetting/activation")) {
      return ["activation"];
    }

    return ["password"];
  };

  const items = [
    getItem(i18next.t("password:Password Policy"), "password", <LockOutlined />),
    getItem(i18next.t("activationConfig:Account Activation Config"), "activation", <ControlOutlined />),
  ];

  return (
    <Layout hasSider style={{height: "100%"}}>
      <Sider width={200}>
        <Menu
          onClick={(menuNode) => {
            const path = menuPath[menuNode.key];
            props.history.push(path);
          }}
          style={{
            height: "100%",
          }}
          defaultSelectedKeys={getDefaultSelectedKeys}
          defaultOpenKeys={getDefaultOpenKeys}
          mode="inline"
          items={items}
        />
      </Sider>
      <Layout style={{padding: "0 0 0 24px", background: "#fff"}}>
        <Content
          className="site-layout-background"
          style={{
            margin: 0,
          }}
        >
          <Switch>
            <Route path="/syssetting/password" render={(props) => <PasswordPolicyPage {...props} />} />
            <Route path="/syssetting/activation" render={(props) => <AccountActivateSetting {...props} />} />
            <Redirect to="/syssetting/password" />
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SystemSetting;
